export const defaultConfig = {
  // baseAPIUrl:"https://laravel9.etrueconcept.com/btpms/api/",
  // imageUrl:"https://laravel9.etrueconcept.com/btpms",
  baseAPIUrllms:"https://ims.braintechnosys.biz/api/",
  
  
  baseAPIUrl:"https://pms.braintechnosys.biz/backend/api/",
  imageUrl:"https://pms.braintechnosys.biz/backend/backend",
};
